import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { SafetyAndHygieneResponsibleService } from '@/infra/services/safety-hygiene-responsible';

interface GetListSafetyAndHygieneResponsibleParams {
	organization_id: string;
	company_id: string;
	name?: string;
	offset?: number;
	limit?: number;
}

const Service = SafetyAndHygieneResponsibleService.getInstance();

export const useGetListSafetyAndHygieneResponsible = (params: GetListSafetyAndHygieneResponsibleParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_SAFETY_AND_HYGIENE_RESPONSIBLE, params],
		queryFn: async () => Service.index(params),
		enabled: isEnabled
	});
};
